import Layout from '@/layout'

// 学生管理
const route = {
  path: '/student/index',
  component: Layout,
  redirect: '/student/list',
  alwaysShow: true,
  name: 'Student',
  meta: {
    title: 'Student',
    icon: 'el-icon-user',
    roles: [
      'larke-admin.ext.student.index'
    ]
  },
  sort: 101000,
  children: [
    {
      path: '/student/list',
      component: () => import('./views/index'),
      name: 'StudentList',
      meta: {
        title: 'StudentList',
        icon: 'el-icon-user',
        roles: [
          'larke-admin.ext.student.index'
        ]
      }
    }

  ]
}

export default route